<ng-container *transloco="let t">
  <homi-website-logo [size]="WebsiteLogoSize.SMALL" class="logo" />
  <div class="top-bar-inner">
    <button
      data-testid="feedback-button"
      lyceoButton
      [status]="ComponentStatus.SECONDARY"
      [size]="ButtonSize.SMALL"
      (click)="feedbackButton()"
    >
      {{ t('feedback.button') }}
    </button>
  </div>
</ng-container>
